if($('header#header').length){  
  //$('.navigation-buttons>a.cart-count').clone().appendTo('.responsive-tools')
  //$('.responsive-tools').clone().appendTo('.navigation-buttons')
  $('nav#navigation').clone().appendTo('.header-top')
  $('nav#navigation li a').on('click', function(){
    $('body').removeClass('top-menu-trigger-visible user-action-visible navigation-window-visible')
  })
  $('a.cart-count').removeClass('toggle-window')
  }

